import { useEffect, useState } from "react";

interface ScreenSizeProps {
  breakpoint?: number;
}

const useScreenSize = ({ breakpoint = 1024 }: ScreenSizeProps) => {
  const [screenSize, setScreenSize] = useState({
    width: 0,
    height: 0,
  });

  const [isMobile, setIsMobile] = useState<boolean>(false);

  useEffect(() => {
    const handleResize = () => {
      setScreenSize({
        width: window.innerWidth,
        height: window.innerHeight,
      });
    };

    handleResize();

    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  useEffect(() => {
    if (screenSize.width <= breakpoint) {
      setIsMobile(true);
    } else {
      setIsMobile(false);
    }
  }, [screenSize, breakpoint]);

  return { screenSize, isMobile };
};

export default useScreenSize;
